const getters = {
  sidebar: state => state.app.sidebar,
  menu: state => state.app.menu,
  userDetal: state => state.user.userDetal,
  loadingMessage: state => state.app.loadingMessage,
  accessToken: state => state.user.accessToken,
  appToken: state => state.user.appToken,
  openFlag: state => state.user.openFlag,
  getBreadcrumb: state => level => {
    if (state.app.breadcrumb[level]) {
      return state.app.breadcrumb[level];
    } else {
      if (
        localStorage.getItem("breadcrumb") &&
        localStorage.getItem("breadcrumb")[level]
      ) {
        return localStorage.getItem("breadcrumb")[level];
      } else {
        return {};
      }
    }
  },
  //合同
  getContractPriceIncludeTax: state =>
    state.contractDraft.contractPriceIncludeTax,
  getContractPriceExcludeTax: state =>
    state.contractDraft.contractPriceExcludeTax,
  getEchoProtocalData: state => state.contractDraft.echoProtocalData,
  getPurchaseListStatus: state => state.contractDraft.purchaseListStatus,
  getOrgId: state => state.contractDraft.orgId,
  getProtocalObj: state => state.contractDraft.protocalCode,
  getMultiRateCode: state => state.contractDraft.isMultiRateCode,
  getProtocalData: state => state.contractDraft.protocalData,
  getDelectList: state => state.contractDraft.setDelectList,
  getSpecificationsArr: state => state.contractDraft.specificationsArr,
  getMultiRateStatus: state => state.contractDraft.isMultiRateStatus,
  getAgreementSelectStatus: state => state.contractDraft.agreementSelectStatus,
  getRemoveInventoryList: state => state.contractDraft.removeInventoryList,
  getRouteUrl: state => state.contractDraft.routeUrl,
  getTableHeadRuleNode: state => state.contractDraft.tableHeadRuleNode,
  getUploadFileRules: state => state.contractDraft.uploadFileRules,
  businessList: state => state.business.businessList,
  shopList: state => state.shopChange.shopList
};
export default getters;
